import {
  SET_FILTER,
  SET_FILTER_SUCCESS,
  SET_FILTER_ERROR,
  REMOVE_FILTER,
  REMOVE_FILTER_SUCCESS,
  REMOVE_FILTER_ERROR
} from './filterSlice';

// Initial state
const initialState = {
  filters: {
    groups: null,
    search: null
  },
  loading: false,
  error: null
};

// Reducer
const filterReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_FILTER:
      return {
        ...state,
        loading: true,
        error: null
      };
    case SET_FILTER_SUCCESS:
      return {
        ...state,
        filters: action.payload,
        loading: false,
        error: null
      };
    case SET_FILTER_ERROR:
      return {
        ...state,
        loading: false,
        error: action.payload
      };
    case REMOVE_FILTER:
      return {
        ...state,
        loading: true,
        error: null
      };
    case REMOVE_FILTER_SUCCESS:
      return {
        ...state,
        filters: {
          groups: null,
          search: null
        },
        loading: false,
        error: null
      };
    case REMOVE_FILTER_ERROR:
      return {
        ...state,
        loading: false,
        error: action.payload
      };
    default:
      return state;
  }
};

export default filterReducer;